import {isNil} from 'lodash'

export const getPackTypeFor = (packTypeId, packTypes = []) => {
  if (isNil(packTypeId)) return null
  return packTypes.find(packType => packType.id === packTypeId)
}
